import { IConnectionDrawingOptions } from '..';
import {
	ProjectState,
	FunctionDeclarationState,
	FunctionCallState,
	ChangeSet,
	ChangeSetEntityChangeType,
} from '@elyx-code/project-logic-tree';
import { connectPassthroughCallable } from './utils';

export function createFunctionCallFromFunctionDeclaration(
	from: FunctionDeclarationState,
	connectionOptions: IConnectionDrawingOptions,
	project: ProjectState,
	changeSet: ChangeSet
): FunctionCallState {
	// Create a new function call of this function declaration at this coordinates
	const newCall = from.createCall(changeSet);

	changeSet.add(newCall, ChangeSetEntityChangeType.Added);

	connectPassthroughCallable(newCall, connectionOptions, project, changeSet);

	return newCall;
}
